const Dailyexpensereducer = (state, { type, payload }) => {
    switch (type) {
        case 'setdaily':
            return { ...state, daily_expense: payload.daily_expense };
        default:
            return state;
    }
}

export default Dailyexpensereducer;